import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { identifyUser, resetIdentity } from '../../utils/analytics';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { user, isLoading } = useAuthStore();
  const location = useLocation();

  // Identify user with PostHog when they log in
  useEffect(() => {
    if (user) {
      // Identify the user in PostHog
      identifyUser(user.id, {
        email: user.email,
        name: user.name,
        role: user.role,
      });
    } else {
      // Reset identity when user logs out
      resetIdentity();
    }
  }, [user]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user && !location.pathname.startsWith('/auth')) {
    const redirectTo = `/auth/login${location.search}`;
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (user && location.pathname.startsWith('/auth')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};